module.exports = "<div class=\"internationalization\">\r\n    <select id=\"languageValue\" data-bind=\"event:{change:setLanguage},value:lan\">\r\n        <option value=\"zh_CN\">中文(简体)</option>\r\n        <option value=\"en_US\">English</option>\r\n    </select>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/Language.html
// module id = 92
// module chunks = 0